import { createContext } from "react";
import { selectedTenant } from "../Auth/types";
import { GenericList } from "../Logic/TenantAPI";
import { iMailboxConfig } from "../Logic/config";

export interface iTenantContext {
    selectedTenant: selectedTenant | undefined;
    departments: GenericList[];
    mailboxes: GenericList[];
    actions: GenericList[];
    mailboxEditorConfigurations: { id: number; config: iMailboxConfig }[];
    setSelectedTenant: React.Dispatch<React.SetStateAction<selectedTenant | undefined>>;
    setDepartments: React.Dispatch<React.SetStateAction<GenericList[]>>;
}

const initialValues: iTenantContext = {
    selectedTenant: undefined,
    departments: [],
    mailboxes: [],
    actions: [],
    setSelectedTenant: () => {},
    setDepartments: () => {},
    mailboxEditorConfigurations: [],
};

export const tenantContext = createContext(initialValues);
